import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button.jsx";

const styles = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "16px"
  },
  modalBox: {
    backgroundColor: "white",
    borderRadius: "10px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
    width: "100%",
    maxWidth: "720px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    padding: "18px"
  },
  title: {
    margin: "0 0 10px",
    color: "#1b2a41"
  },
  subTitle: {
    margin: "0 0 16px",
    color: "#66788a",
    fontSize: "13px"
  },
  field: {
    marginBottom: "16px"
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "4px"
  },
  errorText: {
    marginRight: "auto",
    color: "#c62828",
    fontSize: "13px"
  },
  "@media (max-width: 600px)": {
    modal: {
      alignItems: "flex-start",
      padding: "8px"
    },
    modalBox: {
      maxHeight: "calc(100vh - 16px)",
      padding: "14px"
    },
    footer: {
      flexDirection: "column",
      alignItems: "stretch"
    }
  }
};

class TrainingPlanEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.initialTitle || "",
      description: props.initialDescription || ""
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.open !== this.props.open ||
      prevProps.initialTitle !== this.props.initialTitle ||
      prevProps.initialDescription !== this.props.initialDescription
    ) {
      this.setState({
        title: this.props.initialTitle || "",
        description: this.props.initialDescription || ""
      });
    }
  }

  handleSave = () => {
    const { title, description } = this.state;
    this.props.onSave({ title: title.trim(), description: description.trim() });
  };

  render() {
    const { classes, open, onClose, saving, error, dayLabel } = this.props;
    const { title, description } = this.state;

    return (
      <Modal
        open={open}
        onClose={onClose}
        className={classes.modal}
        aria-labelledby="training-plan-editor-modal"
      >
        <Box className={classes.modalBox}>
          <h3 className={classes.title}>Edit Training Plan</h3>
          <p className={classes.subTitle}>{dayLabel}</p>

          <TextField
            className={classes.field}
            label="Training Title"
            fullWidth
            value={title}
            onChange={event => this.setState({ title: event.target.value })}
          />

          <TextField
            className={classes.field}
            label="Plan Details"
            fullWidth
            multiline
            rows={6}
            value={description}
            onChange={event =>
              this.setState({ description: event.target.value })
            }
          />

          <div className={classes.footer}>
            {error && <div className={classes.errorText}>{error}</div>}
            <Button color="default" onClick={onClose} disabled={saving}>
              Cancel
            </Button>
            <Button color="info" onClick={this.handleSave} disabled={saving}>
              {saving ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </Box>
      </Modal>
    );
  }
}

TrainingPlanEditor.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  initialTitle: PropTypes.string,
  initialDescription: PropTypes.string,
  dayLabel: PropTypes.string,
  saving: PropTypes.bool,
  error: PropTypes.string
};

TrainingPlanEditor.defaultProps = {
  open: false,
  onClose: () => {},
  onSave: () => {},
  initialTitle: "",
  initialDescription: "",
  dayLabel: "",
  saving: false,
  error: ""
};

export default withStyles(styles)(TrainingPlanEditor);
